import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default, { useState } from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import 'moment';

function Switch(props) {
  var falseOptionLabel = props.falseOptionLabel,
    trueOptionLabel = props.trueOptionLabel,
    active = props.active,
    onStatusChange = props.onStatusChange,
    disabled = props.disabled,
    withoutLabels = props.withoutLabels;
  var _useState = useState(active),
    _useState2 = _slicedToArray(_useState, 2),
    switchStatus = _useState2[0],
    setSwitchStatus = _useState2[1];
  function changeStatus(status) {
    if (disabled) {
      return false;
    }
    setSwitchStatus(status);
    onStatusChange(status);
    return true;
  }
  var handleFalseOptionClick = function handleFalseOptionClick() {
    return changeStatus(false);
  };
  var handleTrueOptionClick = function handleTrueOptionClick() {
    return changeStatus(true);
  };
  var handleSwitchReferenceClick = function handleSwitchReferenceClick() {
    return changeStatus(!switchStatus);
  };
  var referencePositionCls = switchStatus ? 'bf-switch-reference-position-left' : 'bf-switch-reference-position-right';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-switch-wrapper \n            ".concat(disabled ? 'bf-switch-is-disabled' : '', " \n            ").concat(withoutLabels ? 'bf-switch-without-labels' : '')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-switch-option bf-switch-option-false ".concat(!switchStatus ? 'bf-switch-option-is-selected' : ''),
    onClick: handleFalseOptionClick
  }, !withoutLabels && falseOptionLabel), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-switch-reference-wrapper ".concat(referencePositionCls),
    onClick: handleSwitchReferenceClick
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "bf-switch-reference"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "bf-switch-option bf-switch-option-true ".concat(switchStatus ? 'bf-switch-option-is-selected' : ''),
    onClick: handleTrueOptionClick
  }, !withoutLabels && trueOptionLabel));
}
Switch.defaultProps = {
  falseOptionLabel: 'No',
  trueOptionLabel: 'Yes',
  active: false,
  onStatusChange: function onStatusChange() {},
  disabled: false,
  withoutLabels: false
};
Switch.propTypes = {
  /**
  False / Inactive option text
   */
  falseOptionLabel: nodeOrStringProp,
  /**
  True / Active option text
   */
  trueOptionLabel: nodeOrStringProp,
  /**
  Default Switch status
   */
  active: PropTypes.bool,
  /**
  Function triggered on Switch status modification
   */
  onStatusChange: PropTypes.func,
  /**
  Disabled state
   */
  disabled: PropTypes.bool,
  /**
  Remove Switch options text
   */
  withoutLabels: PropTypes.bool
};

export default Switch;
